import React from 'react';

const getInitials = (fullName) => {
  if (!fullName) return '?';
  
  const names = fullName.trim().split(' ');
  if (names.length === 0) return '?';
  
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase();
  }
  
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
};

const getRandomColor = (name) => {
  if (!name) return '#808080';
  
  const colors = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEEAD',
    '#D4A5A5', '#9B59B6', '#3498DB', '#1ABC9C', '#2ECC71'
  ];
  const firstChar = (name || '').split('')[0]?.toLowerCase() || 'a';
  const charCode = firstChar.charCodeAt(0);
  return colors[charCode % colors.length];
};

const InitialsAvatar = ({ name, className = '' }) => {
  return (
    <div
      className={`flex items-center justify-center rounded-full bg-opacity-80 ${className}`}
      style={{ backgroundColor: getRandomColor(name) }}
    >
      <span className="text-white font-medium text-sm">
        {getInitials(name)}
      </span>
    </div>
  );
};

export default InitialsAvatar; 